import { useCallback, useEffect, useState } from 'react'

const useActiveTab = ({
  initialActiveTabId,
  controlledActiveTabId,
  onChange,
}: {
  initialActiveTabId: string
  controlledActiveTabId?: string
  onChange?: OnChange
}) => {
  const [activeTabId, setActiveTabId] = useState<string>(controlledActiveTabId || initialActiveTabId)

  useEffect(() => {
    if (controlledActiveTabId) setActiveTabId(controlledActiveTabId)
  }, [controlledActiveTabId])

  const handleChange = useCallback(
    (tabId: string) => {
      if (activeTabId !== tabId) {
        setActiveTabId(tabId)
        if (onChange) onChange(tabId)
      }
    },
    [onChange, activeTabId],
  )

  return { handleChange, activeTabId }
}

type OnChange = (tabId: string) => void

export default useActiveTab
